import { render, staticRenderFns } from "./Fotter.vue?vue&type=template&id=34658a88&"
import script from "./Fotter.vue?vue&type=script&lang=js&"
export * from "./Fotter.vue?vue&type=script&lang=js&"
import style0 from "./Fotter.vue?vue&type=style&index=0&id=34658a88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCard,VCardText,VFooter})
